"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toFloat = exports.calcRatio = exports.isNumeric = exports.sum = exports.formatKprice = exports.formatNumberMini = exports.formatNumber = void 0;

var formatNumber = function formatNumber(v) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  var delimiter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '\'';
  var pf = v;

  if (isNaN(pf)) {
    return '';
  }

  var re = precision > 0 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(\d{3})+$)/g;
  return pf.toFixed(precision).replace(re, '$1\'');
};

exports.formatNumber = formatNumber;

var formatNumberMini = function formatNumberMini(v) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

  if (isNaN(v)) {
    return '';
  }

  return Number(v).toFixed(precision);
};

exports.formatNumberMini = formatNumberMini;

var formatKprice = function formatKprice(v) {
  if (isNaN(v)) {
    return '';
  }

  return Math.round(v).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

exports.formatKprice = formatKprice;

var sum = function sum(arr) {
  return arr.reduce(function (a, b) {
    return a + b;
  }, 0);
};

exports.sum = sum;

var isNumeric = function isNumeric(value) {
  return !isNaN(parseFloat(value)) && isFinite(value);
};

exports.isNumeric = isNumeric;

var calcRatio = function calcRatio(a, b) {
  var r = 100 * a / b;
  var t = '';

  if (isNaN(r)) {
    t = '';
  } else {
    t = formatNumber(r);
  }

  if (!isFinite(r)) {
    t = "\u221E";
  }

  return t;
};

exports.calcRatio = calcRatio;

var toFloat = function toFloat(s) {
  if (!s || s === null || s === '') {
    return NaN;
  }

  return Number(s.replace(/[',]/g, ''));
};

exports.toFloat = toFloat;